<template>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-btn color="primary" dark slot="activator">
                <v-icon small>$vuetify.icons.rms_create</v-icon>
                {{ $t('rms.button.create') }}
            </v-btn>
            <v-card>
                <v-card-title primary-title>
                    <div class="title">{{ $t('film.maker.new.create.dialog') }}</div>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mx-0"
                        small
                        dark
                        icon
                        color="grey"
                        @click.native="resetAndClose()"
                    >
                        <v-icon small>$vuetify.icons.rms_close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex>
                            <v-text-field
                                v-model="filmMaker.name[currentLocale]"
                                name="filmmakers_name"
                                :label="$t('film.makers.update.page.form.field.name')"
                                outline
                                :rules="[
                                    rules.required,
                                    rules.min_length(3),
                                    rules.max_length(250),
                                ]"
                            ></v-text-field>
                            <v-select
                                :items="DEFINES.FILMMAKER.TYPES"
                                v-model="filmMaker.type"
                                :label="$t('film.makers.update.page.form.field.type')"
                                outline
                                item-value="value"
                                :rules="[
                                    rules.required,
                                ]"
                            ></v-select>
                            <v-textarea
                                v-model="filmMaker.short_description[currentLocale]"
                                name="filmmakers_name"
                                :label="$t('film.makers.update.page.form.field.short_description')"
                                outline
                                :rules="[
                                    rules.required,
                                    rules.min_length(3),
                                    rules.max_length(250),
                                ]"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="dialog = false">
                        {{$t('film.maker.new.create.dialog.action.close')}}
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click.native="create()">
                        {{ $t('film.maker.new.create.dialog.action.create') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

</template>
<script>
import i18n from '@/i18n'
import DEFINES from '@/defines'
import rules from '@/validation'
export default {
    name: "NewFilmMakerDialog",
    data() {
        return {
            rules,
            dialog: false,
            filmMaker: {
                name: {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    it : ''
                },
                short_description: {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    it : ''
                },
                filmography: {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    it : ''
                },
                type: null,
                profile_picture: null
            },
            loading: false
        }
    },
    computed:{
        currentLocale() {
            return this.$i18n.locale;
        }
    },
    methods: {
        reset() {
            return this.filmMaker = {
                name: '',
                short_description: '',
                filmography: '',
                type: null,
                profile_picture: null
            }
        },
        resetAndClose() {
            this.reset();
            this.dialog = false
        },
        async create() {
            this.loading = true
            await this.$store.dispatch('filmMaker/create', this.filmMaker)
            .then((response) => {
                this.$store.dispatch("app/showMessage", {
                    message: i18n.t('film.maker.new.create.dialog.action.create.success.message'),
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
                });
                this.resetAndClose();
                this.$emit('created')
            })
            .catch((error) => {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: this.DEFINES.SNACKBAR_ERROR_COLOR,
                });
            })
            .finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
